const newsDetailReducer = (state = 0 ,action)=>{
    switch(action.type){
            case 'NDSET':
                return state = action.payload;
            default:
                return state;
    }
}

export default newsDetailReducer;